/**
 * Global mobile search mount.
 *
 * Listens for the `granbay.mobilesearch.open` window event and shows
 * V6MobileSearchSheet (the Polymarket-style fullscreen-from-bottom
 * sheet with search input + Browse chips + Topics grid). The event
 * fires from the SiteHeader mobile-only search icon button so phone
 * viewers get the fullscreen sheet instead of the desktop CmdK
 * palette modal.
 *
 * Sits dormant on desktop — the SiteHeader's CmdK trigger continues
 * to fire `granbay.cmdk.open` for the keyboard-driven palette and
 * never reaches this listener.
 */
"use client";

import { useCallback, useEffect, useState } from "react";
import { V6MobileSearchSheet } from "@/components/v6/MobileSearchSheet";

export function V6GlobalMobileSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("granbay.mobilesearch.open", handler);
    return () =>
      window.removeEventListener("granbay.mobilesearch.open", handler);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  return <V6MobileSearchSheet open={open} onClose={close} />;
}
